module.exports = __webpack_public_path__ + "img/network.5c9d4aeb.jpg";